import React from "react";
import { useSelector } from "react-redux";
import packageJson from "../../../package.json";

const Footer = () => {
  const env = useSelector(state => state.settings.env);
  const buildVersion = packageJson.version;
  const currentYear = new Date().getFullYear();

  return (
    <footer className="app-footer">
      <span className="d-inline-block">{`iFlip Investor LLC © ${currentYear}`}</span>
      <span className="">{`Env: ${env} | Build: ${buildVersion}`}</span>
    </footer>
  );
};
export default Footer;
